import React from "react";
import MainBookShelf from "./Screens/MainBookshelf";
import CreateBook from "./Screens/CreateBook";
import BookReader from "./Screens/BookReader";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={MainBookShelf} />
        <Route exact path="/createbook" component={CreateBook} />
        <Route exact path="/bookreader/:id" component={BookReader} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
